const applySort = (select) => {
    const searchParams = new URLSearchParams(window.location.search);

    searchParams.delete("page");
    searchParams.set("sort_by", select.value);

    window.location = `${window.location.pathname}?${searchParams.toString()}`;
};

document.querySelectorAll("#sort-form select").forEach((sortSelect) => {
    sortSelect.addEventListener("change", (event) => {
        event.preventDefault();
        applySort(sortSelect);
    });
});
